import { motion } from 'framer-motion';
import { BsHeartFill } from 'react-icons/bs';
import FireworksCelebration from './FireworksCelebration';

const CountdownTimer = ({ timeLeft }) => {
    const isTimeUp = timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0;

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8 mt-12 max-w-4xl mx-auto px-4">
            {[
                { label: 'Ngày', value: timeLeft.days },
                { label: 'Giờ', value: timeLeft.hours },
                { label: 'Phút', value: timeLeft.minutes },
                { label: 'Giây', value: timeLeft.seconds },
            ].map(({ label, value }, index) => (
                <motion.div
                    key={label}
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{
                        duration: 0.8,
                        delay: index * 0.1,
                        type: "spring",
                        stiffness: 100,
                    }}
                    className="relative group"
                >
                    <motion.div
                        animate={{
                            scale: [1, 1.02, 1],
                            rotate: [0, 1, -1, 0],
                        }}
                        transition={{
                            duration: 1,
                            repeat: Infinity,
                            repeatDelay: 1,
                        }}
                        className="bg-gradient-to-br from-pink-50 via-white to-yellow-50 p-6 md:p-8 rounded-[2rem] shadow-xl 
                        border-[3px] border-pink-300 flex flex-col items-center justify-center
                        group-hover:border-yellow-400 group-hover:shadow-2xl 
                        transition-all duration-500"
                    >
                        {/* Decorative elements */}
                        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                            <motion.div
                                animate={{ scale: [1, 1.2, 1] }}
                                transition={{ duration: 2, repeat: Infinity }}
                            >
                                <BsHeartFill className="text-pink-400 text-2xl drop-shadow" />
                            </motion.div>
                        </div>

                        {/* Number value */}
                        <motion.span
                            key={value}
                            initial={{ y: -20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: 20, opacity: 0 }}
                            transition={{ type: "spring", stiffness: 200 }}
                            className="block text-5xl md:text-6xl lg:text-7xl font-bold text-rose-500 
                            font-cursive mb-2 relative"
                        >
                            {String(value).padStart(2, '0')}

                            {/* Pulse effect */}
                            <motion.div
                                key={`pulse-${value}`}
                                initial={{ scale: 1, opacity: 0.5 }}
                                animate={{ scale: 2, opacity: 0 }}
                                transition={{ duration: 1, ease: "easeOut" }}
                                className="absolute inset-0 bg-pink-100 rounded-full -z-10"
                            />
                        </motion.span>

                        {/* Label */}
                        <span className="text-lg md:text-xl font-serif text-gray-800 
                        group-hover:text-pink-600 transition-colors duration-300 
                        relative z-10"
                        >
                            {label}
                        </span>

                        {/* Background */}
                        <div className="absolute inset-0 bg-gradient-to-br from-pink-100 to-white 
                        rounded-[2rem] opacity-50 group-hover:opacity-70 transition-opacity duration-500"
                        />
                    </motion.div>

                    {/* Bottom dot */}
                    <motion.div
                        animate={{
                            y: [0, -5, 0],
                            scale: [1, 1.2, 1],
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            delay: index * 0.2,
                        }}
                        className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-3 h-3 
                        bg-pink-400 rounded-full shadow-md"
                    />
                </motion.div>
            ))}
            {isTimeUp && (
                <motion.div
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                    className="col-span-2 md:col-span-4 text-center mt-8"
                >
                    <span className="text-4xl md:text-5xl lg:text-6xl font-cursive text-pink-700">
                        Chúc mừng! Đám cưới tuyệt đẹp đã đến 💕
                    </span>
                </motion.div>
            )}
        </div>
    );
};

export default CountdownTimer;
